import { useEffect, useRef, useState } from 'react';
export var useModalAnimationState = function (_a) {
    var isOpen = _a.isOpen, onClose = _a.onClose;
    var _b = useState('exited'), animationState = _b[0], setAnimationState = _b[1];
    var prevIsOpenRef = useRef(isOpen);
    useEffect(function () {
        var prevIsOpen = prevIsOpenRef.current;
        prevIsOpenRef.current = isOpen;
        // Opening: was closed, now open
        if (!prevIsOpen && isOpen) {
            setAnimationState('entering');
            var timer_1 = setTimeout(function () {
                setAnimationState('entered');
            }, 300);
            return function () { return clearTimeout(timer_1); };
        }
        // Closing: was open, now closed
        if (prevIsOpen && !isOpen) {
            setAnimationState('exiting');
            var timer_2 = setTimeout(function () {
                setAnimationState('exited');
            }, 200);
            return function () { return clearTimeout(timer_2); };
        }
        return undefined;
    }, [isOpen]);
    var handleCloseWithAnimation = function () {
        if (animationState === 'entered' || animationState === 'entering') {
            setAnimationState('exiting');
            setTimeout(function () {
                onClose();
            }, 200);
        }
        else {
            onClose();
        }
    };
    var isOpenOrClosing = isOpen || animationState !== 'exited';
    return { animationState: animationState, handleCloseWithAnimation: handleCloseWithAnimation, isOpenOrClosing: isOpenOrClosing };
};
